export default "<canvas id=\"game\" #game>\n</canvas>\n<div *ngIf=\"mobile\">\n  <script>alert(1)</script>\n</div>\n"